/*
 * @Author: 汪俊洪
 * @Date: 2021-03-13 14:43:56
 * @LastEditTime: 2021-08-19 10:43:13
 * @LastEditors: 汪俊洪
 * @Description: 加减乘除
 */

// 加法
export function add (a, b) {
  let c, d, e
  try {
    c = a.toString().split('.')[1].length
  } catch (f) {
    c = 0
  }
  try {
    d = b.toString().split('.')[1].length
  } catch (f) {
    d = 0
  }
  // eslint-disable-next-line no-sequences
  return (e = Math.pow(10, Math.max(c, d))), (mul(a, e) + mul(b, e)) / e
}

// 减法
export function sub (a, b) {
  let c, d, e
  try {
    c = a.toString().split('.')[1].length
  } catch (f) {
    c = 0
  }
  try {
    d = b.toString().split('.')[1].length
  } catch (f) {
    d = 0
  }
  // eslint-disable-next-line no-sequences
  return (e = Math.pow(10, Math.max(c, d))), (mul(a, e) - mul(b, e)) / e
}
// 乘法
export function mul (a, b) {
  let c = 0
  const d = a.toString()
  const e = b.toString()
  try {
    c += d.split('.')[1].length
  } catch (f) {
    // console.log(f);
  }
  try {
    c += e.split('.')[1].length
  } catch (f) {
    // console.log(f);
  }
  return (
    (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  )
}
// 除法
export function div (a, b) {
  let c
  let d
  let e = 0
  let f = 0
  try {
    e = a.toString().split('.')[1].length
  } catch (g) {
    // console.log(g);
  }
  try {
    f = b.toString().split('.')[1].length
  } catch (g) {
    // console.log(g);
  }
  return (
    (c = Number(a.toString().replace('.', ''))),
    (d = Number(b.toString().replace('.', ''))),
    mul(c / d, Math.pow(10, f - e))
  )
}

// 百分比计算，a/b 截取 保留两位小数。若a不为0 但结果为0.00% 转为0.01%；若a<b 但结果为100.00% 转为99.99%
// hasSign是否返回%
export function computedRate (a, b, hasSign = true) {
  let res = 0
  if (b && Number(b) > 0) {
    // const orjNum = mul(div(a || 0, b || 0), 100)
    // const orjNum = mul((a / b), 100)
    // res = div(Math.floor(mul(orjNum, 100)), 100).toFixed(2)
    res = div(Math.floor(div(mul(a || 0, 10000), b)), 100).toFixed(2)
    if (Number(res) === 0 && Number(a) !== 0) {
      res = '0.01'
    } else if (Number(res) === 100 && Number(a) < Number(b)) {
      res = '99.99'
    }
    if (hasSign) res += '%'
  } else {
    res = '-'
  }
  return res
}
